import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography, InputLabel } from '@mui/material';
import React, { ChangeEvent } from 'react';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';

export type AlertInfoFileTypePropsType = {
  text: string
  addFile: (event: ChangeEvent<HTMLInputElement>) => void
}

export const AlertInfoFileType = (props: AlertInfoFileTypePropsType) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOnOK = () => {
    setOpen(false);
  }

  const onAddFile = (event: ChangeEvent<HTMLInputElement>) => {

    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      if(file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp') {
        props.addFile(event)
      } else {
        setOpen(true)
      }
  }
}

  return (
    <div >
      <InputLabel htmlFor="fileInput">
        <AddPhotoAlternateIcon className='addFotoBtn' fontSize='large' id='icon' />
      </InputLabel>
      <input
        id='fileInput'
        type="file"
        name="myImage"
        onChange={(event) => onAddFile(event)} />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{display: "flex", alignItems: "center"}}>
          <WarningOutlinedIcon color="warning" fontSize='large' style={{paddingRight: '14px' }}/>
          {" "}
          {"Unsupported file type! "}
           
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           {props.text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseOnOK} variant="contained" color="info" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
